import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { invokeDie } from '../../die.type';
import { ModifierPriority } from '../../modifier.type';
import { DieFace } from '../../face.type';

export class ManaBornTrait extends Trait {
  static baseType = TraitType.ManaBorn;
  static baseTitle = 'Mana Born';
  static baseText = 'When using a technique with mana, invoke mana once per turn.';
  static baseIcon = 'trait';

  type = ManaBornTrait.baseType;
  title = ManaBornTrait.baseTitle;
  text = ManaBornTrait.baseText;
  icon = ManaBornTrait.baseIcon;

  init() {
    super.init();
    this.properties = { manaInvoked: false };
  }

  startTurn({ dice, rerollMax, activePlayer, inactivePlayer }: any): void {
    this.properties.manaInvoked = false;
  }

  damageOut(damage: any): void {
    if (
      !this.properties.manaInvoked &&
      damage.dice &&
      damage.dice.find((die: any) => die.value().includes(DieFace.Mana))
    ) {
      this.properties.manaInvoked = true;
      invokeDie([DieFace.Mana]);
    }
  }
}

TraitRegistry.register(ManaBornTrait.baseType, ManaBornTrait);
